export default __webpack_public_path__ + "static/media/start.b47396cd.svg";